import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

ContentDialogInit.propTypes = {};

export function ContentDialogInit(props) {
  const [openCD, setOpenCD] = useState(false);
  const [tca, setTca] = useState({});
  const [CDActions, setCDActions] = useState(null);

  return {
    openCD,
    setOpenCD,
    tca,
    setTca,
    CDActions,
    setCDActions,
  };
}

ContentDialog.propTypes = {
  openCD: PropTypes.bool.isRequired,
  setOpenCD: PropTypes.func.isRequired,
  tca: PropTypes.object,
  maxWidth: PropTypes.string,
  centered: PropTypes.bool,
  CDActions: PropTypes.object,
  onClose: PropTypes.func,
  onExited: PropTypes.func,
  disableBackdropClick: PropTypes.bool,
  notFullWidth: PropTypes.bool,
};

export function ContentDialog(props) {
  const {
    openCD,
    setOpenCD,
    tca,
    centered = false,
    CDActions = null,
    onClose = () => {},
    onExited,
    disableBackdropClick = true,
  } = props;

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") return;
    setOpenCD(false);
    onClose();
  };

  return (
    <Dialog
      open={openCD}
      onClose={handleClose}
      maxWidth={props.tca.maxWidth || props.maxWidth || "md"}
      fullWidth={!props.notFullWidth}
      PaperProps={{ sx: { borderRadius: "16px" } }}
      slotProps={onExited ? { transition: { onExited } } : undefined}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {tca?.title}
          <Box sx={{ pr: 5 }}>
            {CDActions?.top && CDActions.top}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent
        dividers
        sx={
          centered
            ? {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }
            : {}
        }
      >
        {tca?.content}
      </DialogContent>
      {tca.actions && (
        <DialogActions sx={{ padding: "16px" }}>{tca?.actions}</DialogActions>
      )}
      {CDActions?.bottom && (
        <DialogActions sx={{ padding: "16px" }}>
          {CDActions.bottom}
        </DialogActions>
      )}
    </Dialog>
  );
}
